<script setup>
import { onMounted, ref, defineExpose, defineProps, defineEmits, } from 'vue';
import { uploadFile, user_company_address_v3 } from "@/service";
import { putProductLine, postProductLine, gethscodeByTemplate } from "@/service/apiList/productLine"
import { showMessage } from "@/utils/hooks/message";
import SwiperTool from "@/components/swiperTool.vue";
import { getLangValue, getLangValueByKey } from "@/utils/common"; //获取后端语言
import i18n from "@/i18n"
const props = defineProps({
    hscodeList: {
        type: Array,
        required: true,
        default: () => []
    },
})
const emits = defineEmits(['closeAndUpdate',])
const formData = ref({
    id: '',
    template_name: '',
    HScode: '',
    place_of_origin: '',
    production_line_number: '',
    production_line_name: '',
    production_line_name_en: '', // 新增英文
    style: [],
    pattern: [],
    destination_market: '',
    place_of_origin_str: '',
})
const currentTabLang = ref(i18n.global.locale == 'en' ? 2 : '1')
const isCheckForm = ref(false)
const formType = ref('add')
const company_address_list = ref([])
const hscodeList1 = ref([])
const destination_market_list = ref([])
const hscode = ref('')
const get_user_company_address = async () => {
    // let data = sessionStorage.getItem('company_address_list') ? JSON.parse(sessionStorage.getItem('company_address_list')) : []
    // if (data.length) {
    //     company_address_list.value = data
    // } else {
    // 获取公司生产地址
    let params = {
        user_id: sessionStorage.getItem('set_menu_list') ? JSON.parse(sessionStorage.getItem('set_menu_list')).user_id : '' //目前登录没有返回
    }
    const resp = await user_company_address_v3(params)
    if (resp) {
        company_address_list.value = resp.payload.map(item => {
            return {
                label: `${item.place_of_origin_number}${item.country}-${item.province}-${item.city}-${item.address1}`,
                value: item.id,
                id: item.id
            }
        })
        sessionStorage.setItem('company_address_list', JSON.stringify(company_address_list.value))
    }
    // }

}

const blurproduction_line_number = () => {
    // var regex = /[^A-Z0-9]/g; // 正则表达式，匹配非大写字母和数字的字符
    formData.value.production_line_number = formData.value.production_line_number?.toUpperCase().replace(/[^A-Z0-9]/g, '');
    // console.log(formData.value.production_line_number);
    if (formData.value.production_line_number && formData.value.production_line_number.length > 6) {
        formData.value.production_line_number = formData.value.production_line_number.slice(0, 6)
    }
}
const checkForm = () => {
    // 验证form
    isCheckForm.value = true;
    let checkRes = true
    if (!formData.value.template_name || !formData.value.HScode.length || !formData.value.production_line_number || !formData.value.production_line_name
        || !formData.value.style.length || !formData.value.pattern.length || !formData.value.production_line_name_en
    ) {
        checkRes = false;
    }
    if (!formData.value.production_line_name_en) {
        currentTabLang.value = 2
    }
    if (!formData.value.production_line_name) {
        currentTabLang.value = 1
    }
    return checkRes;
}
const cancelFunction = () => {
    // 取消  不需要逻辑
    document.getElementById('addBtn').focus();
}
const okFunction = async () => {
    const res = checkForm();
    if (!res) {
        showMessage(
            'danger',
            getLangValue("base.requiredinformation")
        );
        return
    }
    // 长度必须为6
    if (formData.value.production_line_number.length !== 6) {
        showMessage(
            'danger',
            getLangValue("my.product-line", 'product_line_no_length')
        );
        return
    }

    //上传数据
    let params = {
        template_name: formData.value.template_name,
        // hscode: [...formData.value.HScode].pop(),
        // hscode: formData.value.HScode,
        database_template_id: hscode.value,
        // database_template_id: formData.value.HScode,
        production_line_number: formData.value.production_line_number,
        production_line_name: formData.value.production_line_name,
        production_line_name_en: formData.value.production_line_name_en,
        style: formData.value.style.map(item => item.id),
        pattern: formData.value.pattern.map(item => item.id),
        place_of_origin: formData.value.place_of_origin,
    }
    if (formData.value.id) {
        //put
        const resp = await putProductLine(formData.value.id, params)
        // console.log(resp);
        if (resp.code == 0) {
            showMessage("success", getLangValue("base.edit_success"))
            emits('closeAndUpdate')
        } else {
            showMessage("danger", resp.message)
        }
    } else {
        const resp = await postProductLine(params)
        // console.log(resp);
        if (resp.code == 0) {
            isCheckForm.value = false;
            showMessage("success", getLangValue("base.success"))
            emits('closeAndUpdate')
        } else {
            showMessage("danger", resp.message)
        }
    }
}

const changTemplate = async (type=2) => {
    /**模板切换  显示下面的list*/
    formData.value.HScode = ''
    if(type ==1) {
        formData.value.destination_market = '';
        hscodeList1.value = []
    }
    if (!formData.value.id) {
        destination_market_list.value = []
        hscodeList1.value = []
        formData.value.destination_market = '';
    }
    console.log(formData.value.destination_market);
    // formData.value.destination_market = ''
    if (formData.value.template_name) {
        // let arr = props.hscodeList.filter(item => item.name === formData.value.template_name)
        // if (arr.length) {
        //     hscodeList1.value = arr[0].list.map(item => {
        //         return {
        //             label: item.hscode.title,
        //             value: item.id,
        //         }
        //     })
        // }
        // 获取信息
        let role_key = '';
        let arrO = props.hscodeList.find(item => item.name == formData.value.template_name || item.name_en === formData.value.template_name)
        if (arrO) {
            role_key = arrO.role_key;
        }
        const reps = await gethscodeByTemplate({ role_key: role_key })
        if (reps) {
            destination_market_list.value = reps.payload.map(item => {
                return {
                    label: item.title,
                    label_en: item.title_en,
                    value: item.id,
                    database_template_list: item.database_template_list
                }
            })
            // console.log(destination_market_list.value);
            // console.log(formData.value.destination_market);
            if (destination_market_list.value.length) {
                // for (const item in destination_market_list.value) {
                //     const { database_template_list } = destination_market_list.value[item]
                //     // let arr = destination_market_list1.filter(item => item.database_template_id === hscode.value)

                // }
                let arr = destination_market_list.value.filter(item => item.value === formData.value.destination_market)
                if (arr.length) {
                    hscodeList1.value = arr[0].database_template_list.map(item => {
                        return {
                            label: item.hscode?.title,
                            label_en: item.hscode?.title_en,
                            value: item.hscode?.id,
                            database_template_id: item.id,
                            description: item.hscode?.description,
                            description_en: item.hscode?.description_en,
                        }
                    })
                    let arr1 = hscodeList1.value.filter(iitem => iitem.database_template_id == hscode.value)
                    if (arr1.length) {
                        formData.value.HScode = arr1[0].value
                    }
                }
            }

            // hscodeList1.value = reps.payload.map(item => {
            //     return {
            //         label: item.title,
            //         value: item.id,
            //         destination_market_list: item.destination_market_list
            //     }
            // })
            // if(hscode.value) {
            //     // console.log(hscode.value);

            //     for (const item in hscodeList1.value) {
            //         const {destination_market_list:destination_market_list1,value} = hscodeList1.value[item]
            //         let arr=  destination_market_list1.filter(item=> item.database_template_id ===hscode.value )
            //         if(arr.length) {
            //             destination_market_list.value = destination_market_list1;
            //             formData.value.HScode = value
            //             formData.value.destination_market = arr[0].destination_market
            //             // console.log( formData.value.HScode );
            //         }
            //     }
            // }
        }
    }
    // else {
    //     destination_market_list.value = []
    //     hscodeList1.value = []
    //     formData.value.destination_market = '';
    // }
}
const changeHscode = () => {
    // hscode切换
    // destination_market_list.value = []
    // // console.log(formData.value.HScode);
    // if (formData.value.HScode) {
    //     let arr = hscodeList1.value.filter(item => item.value === formData.value.HScode)
    //     if (arr.length) {
    //         destination_market_list.value = arr[0].destination_market_list
    //     }
    // }
    if (formData.value.HScode === '') {
        hscode.value = ''
    } else {
        let arr = hscodeList1.value.filter(item => item.value === formData.value.HScode)
        hscode.value = arr.length ? arr[0].database_template_id : ''
    }

}

const changeDestination_market = () => {
    // 目标市场切换
    if (!formData.value.id) {
        hscode.value = ''
    }
    hscodeList1.value = []
    if (formData.value.destination_market) {
        let arr = destination_market_list.value.filter(item => item.value === formData.value.destination_market)
        console.log(arr);
        if (arr.length) {
            hscodeList1.value = arr[0].database_template_list.map(item => {
                return {
                    label: item.hscode?.title,
                    label_en: item.hscode?.title_en,
                    value: item.hscode?.id,
                    database_template_id: item.id,
                    description: item.hscode?.description,
                    description_en: item.hscode?.description_en,
                }
            })
            // console.log(hscode.value);
        }
    }
}

// const getHscodeList = async () => {
//     const resp = await getHscode()
//     if (resp) {
//         hscodeList.value = resp.payload;
//     }
// }
/**文件上传部分 */
const checkFile = (id, file) => {
    // 根据id判断
    const accept = '.png,.jpeg,.jpg,.dwg,.dwt,.dxf,.dwf,.mp4,.mov,.avi';
    let fileList = []
    if (id == 'style') {
        fileList = [...formData.value.style];
    } else {
        fileList = [...formData.value.pattern];
    }
    let name = /^device\//.test(file.name)
        ? file.name.substring(44)
        : file.name;
    let suffix = name.substring(name.lastIndexOf("."));
    // 判断是否属于指定的类型
    if (accept.indexOf(suffix) == -1) {
        // openAlert(
        //     {
        //         variant: "danger",
        //         content: getLangValue("upload.notCorrectType"),
        //     },
        // );
        showMessage("danger", getLangValue("upload.notCorrectType"))
        return false;
    }
    // 判断是否是同一个文件
    let arr = fileList.filter(item => item.filname == name)
    if (arr.length > 0) {
        // openAlert(
        //     {
        //         variant: "danger",
        //         content: getLangValue("upload.notSameFile"),
        //     },
        // );
        showMessage("danger", getLangValue("upload.notSameFile"))

        return false;
    }
    return true;
}
const selectedFile = (id) => {
    let idStr = '#' + id;
    let fileMaxSize = 1024 * 1024 * 50
    let dropzoneFile = document.querySelector(idStr).files[0];
    if (!dropzoneFile) return;
    if (dropzoneFile.size > fileMaxSize) {
        // openAlert(
        //     {
        //         variant: "danger",
        //         content: getLangValue("upload.limit"),
        //     },
        //     false
        // );
        showMessage("danger", getLangValue("upload.limit"))
        document.getElementById(idStr).value = "";
        return;
    }
    if (!checkFile(id, dropzoneFile)) {
        document.getElementById(idStr).value = "";
        return;
    }
    // console.log(dropzoneFile);
    uploadFile(dropzoneFile)
        .then((res) => {
            if (id == 'style') {
                formData.value.style.push(res.data.payload)
            } else {
                formData.value.pattern.push(res.data.payload)
            }
            // uploadList.value[index].fileList.push(res.data.payload);
        })
        .catch((e) => {
            console.log(e);
        });

}
const drop = (e) => {
    let dropzoneFile = e.dataTransfer.files[0];
    if (!dropzoneFile) return;
}
const deleteFile = (i) => {
    formData.value.style.splice(i, 1);
}

const deleteFile1 = (i) => {
    formData.value.pattern.splice(i, 1);
}

const get_place_of_origin = (place_of_origin_id) => {
    // 获取产地信息
    let arr = company_address_list.value.filter(item => item.id === place_of_origin_id)

    if (arr.length) {
        return arr[0].label
    } else {
        // 如果管理员查看别人的生产地址是看不到的 所以这里要增加一个字符串的显示  地址列表没有信息就显示这个字符串 
        return formData.value.place_of_origin_str ? formData.value.place_of_origin_str : '';
    }
}

const get_hscode = (id) => {
    let arr = hscodeList1.value.filter(item => item.value === id)
    if (arr.length) {
        return i18n.global.locale == 'en' ? arr[0].label_en : arr[0].label
    } else {
        return ''
    }
}

const setType = (filename) => {
    // 获取文件类型
    let fileType = filename.split('.').pop()
    if (fileType == 'jpg' || fileType == 'jpeg' || fileType == 'png' || fileType == 'gif') {
        return 'image'
    }
    return 'file'
}

const editFunction = () => {
    formType.value = 'edit'
}

// const getHscdeAndDestination_market = (info) => {
//     // 根据模板id 复显hscode  目的市场
//     // let arr = hscodeList1.value.filter(item => item.id === id)
//     // if (arr.length) {
//     //     return arr[0].destination_market_list
//     // } else {
//     //     return []
//     // }
//     nextTick(() => {
//         console.log(info);
//         console.log(hscodeList1.value);
//     })

// }

const getHscdeAndDestination_market = (id) => {
    let arr = destination_market_list.value.filter(item => item.value === id)
    if (arr.length) {
        return i18n.global.locale == 'en' ? arr[0].label_en : arr[0].label
    } else {
        return ''
    }
}

/**文件上传部分 */
onMounted(() => {
    // getHscodeList();
    // let x = false
    // if (x)
    //     get_user_company_address()
})

defineExpose({
    formType,
    formData,
    changTemplate,
    get_user_company_address,
    changeHscode,
    changeDestination_market,
    getHscdeAndDestination_market,
    hscode,
})
</script>
<template>

    <div id="myModal" class="modal" tabindex="-1" aria-labelledby="myModalLabel" aria-hidden="false" aria-modal="false"
        data-bs-backdrop="static"
        style="min-height:700px; max-height:1100px;overflow-x: hidden !important; overflow-y: hidden !important; ">
        <div class="modal-dialog " style="top: 20px; height: calc(100% - 30px );">

            <div class="modal-content" style="width: 800px; height: 100%;border: unset;">
                <div class="modal-header p-3 text-white" style="background-color: #333a54;">{{ formType == 'add' ?
                    getLangValue('my.product-line', 'add') : formType == 'edit'
                        ? getLangValue('my.product-line', 'modify_product_line') :
                        getLangValue('my.product-line', 'product_line_detail') }}</div>
                <div class="modal-body px-4 my-scroll-bar py-0"
                    style="height: calc(100% - 62px - 2rem); overflow-y: auto;display: flex; flex-direction: column; justify-content: space-between;">
                    <template v-if="formType != 'view'">
                        <!-- 中英文切换 -->
                        <div class="mt-1">
                            <el-radio-group v-model="currentTabLang" size="" @change="changeLang">
                                <el-radio-button :label="getLangValue('base.chinese')" value="1" />
                                <el-radio-button :label="getLangValue('base.english')" value="2" />
                            </el-radio-group>
                        </div>
                        <div class="my-2">
                            <div>
                                <label class="form-label">
                                    <span>{{ currentTabLang == 1 ?
                                        getLangValueByKey('my.product-line.searchPlaceholder1') :
                                        getLangValueByKey('my.product-line.searchPlaceholder1', 'en') }}</span>
                                    <span class="text-danger">*</span>
                                </label>
                            </div>
                            <div style="height: 40px;">
                                <el-select
                                    :placeholder="currentTabLang == 1 ? getLangValueByKey('my.product-line.searchPlaceholder1') : getLangValueByKey('my.product-line.searchPlaceholder1', 'en')"
                                    v-model="formData.template_name" size="large" style="width: 100%;height: 37.5px;"
                                    :disabled="formType == 'view'" @change="changTemplate(1)"
                                    :class="[(isCheckForm && !formData.template_name) && 'is-invalid']" clearable>
                                    <el-option v-for="item1 in props.hscodeList" :key="item1.key"
                                        :label="currentTabLang == 2 ? item1.name_en : item1.name"
                                        :value="currentTabLang == 2 == 'en' ? item1.name_en : item1.name" />
                                </el-select>
                            </div>
                        </div>
                        <div class="my-2">
                            <div>
                                <label class="form-label">
                                    <span>{{ currentTabLang == 1 ? getLangValueByKey('my.product-line.table_header6') :
                                        getLangValueByKey('my.product-line.table_header6', 'en') }}</span>
                                    <span class="text-danger">*</span>
                                </label>
                            </div>
                            <div style="height: 40px;">
                                <el-select
                                    :placeholder="currentTabLang == 1 ? getLangValueByKey('my.product-line.table_header6') : getLangValueByKey('my.product-line.table_header6', 'en')"
                                    v-model="formData.place_of_origin" size="large" style="width: 100%;height: 37.5px;"
                                    :disabled="formType == 'view'"
                                    :class="[(isCheckForm && !formData.place_of_origin) && 'is-invalid']" clearable>
                                    <el-option v-for="item1 in company_address_list" :key="item1.key"
                                        :label="item1.label" :value="item1.id" />
                                </el-select>
                            </div>
                        </div>
                        <div class="my-2">
                            <div>
                                <label class="form-label">
                                    <span>{{ currentTabLang == 1 ? getLangValueByKey('my.product-line.table_header7') :
                                        getLangValueByKey('my.product-line.table_header7', 'en') }}</span>
                                    <span class="text-danger">*</span>
                                </label>
                            </div>
                            <el-select @change="changeDestination_market"
                                :placeholder="currentTabLang == 1 ? getLangValueByKey('my.product-line.table_header7') : getLangValueByKey('my.product-line.table_header7', 'en')"
                                v-model="formData.destination_market" size="large" style="width: 100%;height: 37.5px;"
                                :disabled="formType == 'view'"
                                :class="[(isCheckForm && !formData.destination_market) && 'is-invalid']" clearable>
                                <el-option v-for="item1 in destination_market_list" :key="item1.key"
                                    :label="currentTabLang == 2 ? item1.label_en : item1.label" :value="item1.value" />
                            </el-select>
                        </div>
                        <div class="my-2">
                            <div>
                                <label class="form-label">
                                    <span>HS Code</span>
                                    <span class="text-danger">*</span>
                                </label>
                            </div>
                            <!-- <input :placeholder="getLangValue('my.product-line','searchPlaceholder2')"
                            :class="[(isCheckForm && !formData.HScode) && 'is-invalid']" v-model="formData.HScode"
                            type="text" class="form-control" required /> -->
                            <!-- <el-cascader size="large" v-model="formData.HScode" style="width: 100%;height: 37.5px;"
                            :options="hscodeList1" :props="{ label: 'title', value: 'id', children: 'children', }"
                            :disabled="formType == 'view'" :placeholder="getLangValue('my.product-line','searchPlaceholder2')" clearable
                            class="my-el" :class="[
                                (isCheckForm && !formData.HScode.length) &&
                                'is-invalid1224',
                            ]" /> -->
                            <el-select @change="changeHscode"
                                :placeholder="currentTabLang == 1 ? getLangValueByKey('my.product-line.searchPlaceholder2',) : getLangValueByKey('my.product-line.searchPlaceholder2', 'en')"
                                v-model="formData.HScode" size="large" style="width: 100%;height: 37.5px;"
                                :disabled="formType == 'view'" filterable
                                :class="[(isCheckForm && !formData.HScode) && 'is-invalid']" clearable>
                                <el-option v-for="item1 in hscodeList1" :key="item1.key"
                                    :label="currentTabLang == 2 ? item1.label_en : item1.label" :value="item1.value">
                                    <span style="float: left; width: 100px;">{{ currentTabLang == 2 ?
                                        item1.label_en :
                                        item1.label }}</span>
                                    <div style="
                                        float: left;
                                        color: #878a99;
                                        font-size: 13px;
                                        width: calc(100% - 100px);
                                        white-space: nowrap; 
                                        overflow: hidden; 
                                        text-overflow: ellipsis;
                                        ">
                                        {{ currentTabLang == 2 ? item1.description_en : item1.description }}
                                    </div>
                                </el-option>
                            </el-select>
                        </div>

                        <div class="my-2">
                            <div>
                                <label class="form-label">
                                    <span>{{ currentTabLang == 1 ? getLangValueByKey('my.product-line.table_header', '') :
                                        getLangValueByKey('my.product-line.table_header', 'en') }}</span>
                                    <span class="text-danger">*</span>
                                </label>
                            </div>
                            <input type="text" @blur="blurproduction_line_number" :max="6"
                                :placeholder="currentTabLang == 1 ? getLangValueByKey('my.product-line.table_header', '') : getLangValueByKey('my.product-line.table_header', 'en')"
                                :class="[(isCheckForm && !formData.production_line_number) && 'is-invalid']"
                                :disabled="formType == 'view'" v-model="formData.production_line_number"
                                class="form-control" required />
                                <div class="text-muted">{{currentTabLang == 1? getLangValueByKey('my.product-line.product_line_name_description', ''):getLangValueByKey('my.product-line.product_line_name_description', 'en')  }}</div>
                        </div>
                        <div class="my-2">
                            <div>
                                <label class="form-label">
                                    <span>{{ currentTabLang == 1 ? getLangValueByKey('my.product-line.table_header1',
                                        '') : getLangValueByKey('my.product-line.table_header1', 'en')}}</span>
                                    <span class="text-danger">*</span>
                                </label>
                            </div>
                            <input type="text" v-show="currentTabLang == 1"
                                :placeholder="getLangValueByKey('my.product-line.table_header1', '')"
                                :class="[(isCheckForm && !formData.production_line_name) && 'is-invalid']"
                                :disabled="formType == 'view'" v-model="formData.production_line_name"
                                class="form-control" required />
                            <input type="text" v-show="currentTabLang == 2"
                                :placeholder="getLangValueByKey('my.product-line.table_header1', 'en')"
                                :class="[(isCheckForm && !formData.production_line_name_en) && 'is-invalid']"
                                :disabled="formType == 'view'" v-model="formData.production_line_name_en"
                                class="form-control" required />
                        </div>
                        <!-- <div class="my-2">
                            <div>
                                <label class="form-label">
                                    <span>{{ getLangValue('my.product-line', 'product_line_name_en') }}</span>
                                    <span class="text-danger">*</span>
                                </label>
                            </div>
                            <input type="text"
                                :placeholder="getLangValue('my.product-line', 'product_line_name_en_placeholder')"
                                :class="[(isCheckForm && !formData.production_line_name_en) && 'is-invalid']"
                                :disabled="formType == 'view'" v-model="formData.production_line_name_en"
                                class="form-control" required />
                        </div> -->
                        <div>
                            <div>
                                <label class="form-label">
                                    <span>{{ currentTabLang == 1 ? getLangValueByKey('my.product-line.table_header3',) :
                                        getLangValueByKey('my.product-line.table_header3', 'en') }}</span>
                                    <span class="text-danger">*</span>
                                </label>
                            </div>
                            <DropZone :class="formType == 'view' ? 'disableDropZone' : ''"
                                :title="currentTabLang == 1 ? getLangValueByKey('upload.title') : getLangValueByKey('upload.title', 'en')"
                                ipt-id="style" accept=".png,.jpeg,.jpg,.dwg,.dwt,.dxf,.dwf,.mp4,.mov,.avi"
                                @drop.prevent="drop" @change.prevent="selectedFile('style')" style="min-height: 200px"
                                :info="currentTabLang == 1 ? getLangValueByKey('my.product-line.upload_info', '') : getLangValueByKey('my.product-line.upload_info', 'en')" />
                            <div class=" border-solid rounded p-1" v-show="formData.style.length"
                                :class="formType == 'view' ? 'disableDropZone' : ''">
                                <div>
                                    <div class="border-primary fs-14 material-title">{{
                                        currentTabLang == 1 ? getLangValueByKey("upload.uploadedFile")
                                            :getLangValueByKey("upload.uploadedFile", 'en') }}
                                    </div>
                                </div>
                                <div style="position: relative;" class="product-img-slider  ps-5 pe-5">
                                    <SwiperTool :swiperInfo="{
                                        type: 'image',
                                        page: 'assetform',
                                        spaceBetween: 10,
                                        slidesPerView: 6,
                                        actionsClass: [
                                            { name: 'ri-eye-fill', action: 'view' },
                                            { name: 'ri-download-2-fill', action: 'download' },
                                            { name: 'ri-delete-bin-5-fill', action: 'delete' },
                                        ],
                                    }" :list="formData.style" @deleteFile="deleteFile">
                                    </SwiperTool>
                                </div>
                            </div>
                        </div>

                        <div class="my-1">
                            <div>
                                <label class="form-label">
                                    <span>{{ currentTabLang == 1 ? getLangValueByKey('my.product-line.table_header4', '') :
                                        getLangValueByKey('my.product-line.table_header4', 'en') }}</span>
                                    <span class="text-danger">*</span>
                                </label>
                            </div>
                            <DropZone :class="formType == 'view' ? 'disableDropZone' : ''"
                                :title="currentTabLang == 1 ? getLangValueByKey('upload.title') : getLangValueByKey('upload.title', 'en')"
                                ipt-id="pattern" accept=".png,.jpeg,.jpg,.dwg,.dwt,.dxf,.dwf,.mp4,.mov,.avi"
                                @drop.prevent="drop" @change.prevent="selectedFile('pattern')" style="min-height: 180px"
                                :info="currentTabLang == 1 ? getLangValueByKey('my.product-line.upload_info', '') : getLangValueByKey('my.product-line.upload_info', 'en')" />
                            <div class=" border-solid rounded p-1" v-show="formData.pattern.length"
                                :class="formType == 'view' ? 'disableDropZone' : ''">
                                <div>
                                    <div class="border-primary fs-14 material-title">{{
                                        currentTabLang == 1 ? getLangValueByKey("upload.uploadedFile")
                                            :getLangValueByKey("upload.uploadedFile", 'en') }}
                                    </div>
                                </div>
                                <div style="position: relative;" class="product-img-slider  ps-5 pe-5">
                                    <SwiperTool :swiperInfo="{
                                        type: 'image',
                                        page: 'assetform1',
                                        spaceBetween: 10,
                                        slidesPerView: 6,
                                        actionsClass: [
                                            { name: 'ri-eye-fill', action: 'view' },
                                            { name: 'ri-download-2-fill', action: 'download' },
                                            { name: 'ri-delete-bin-5-fill', action: 'delete' },
                                        ],
                                    }" :list="formData.pattern" @deleteFile="deleteFile1">
                                    </SwiperTool>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <!-- 展示详情 -->
                        <div class="d-flex flex-wrap justify-content-between">
                            <div style="width: 30%;min-height: 40px;" class="mx-2 my-3">
                                <div>{{ getLangValue('my.product-line', 'searchPlaceholder1') }}</div>
                                <div>{{ formData.template_name }}</div>
                            </div>
                            <div style="width: 30%;min-height: 40px;" class="mx-2 my-3">
                                <div>{{ getLangValue('my.product-line', 'table_header6') }}</div>
                                <div>{{ get_place_of_origin(formData.place_of_origin) }}</div>
                            </div>
                            <div style="width: 30%;min-height: 40px;" class="mx-2 my-3">
                                <div>{{ getLangValue('my.product-line', 'table_header5') }}</div>
                                <div>{{ get_hscode(formData.HScode) }}</div>
                            </div>
                            <div style="width: 30%;min-height: 40px;" class="mx-2 my-3">
                                <div>{{ getLangValue('my.product-line', 'table_header') }}</div>
                                <div>{{ formData.production_line_number }}</div>
                            </div>
                            <div style="width: 30%;min-height: 40px;" class="mx-2 my-3">
                                <div>{{ getLangValue('my.product-line', 'table_header1') }}</div>
                                <div>{{ i18n.global.locale == 'en' ? formData.production_line_name_en :
                                    formData.production_line_name }}</div>
                            </div>
                            <div style="width: 30%;min-height: 40px;" class="mx-2 my-3">
                                <div>{{ getLangValue('my.product-line', 'table_header7') }}</div>
                                <div>{{ getHscdeAndDestination_market(formData.destination_market) }}</div>
                            </div>
                            <div style="width: 100%;min-height: 40px;" class="mx-2 my-3">
                                <div>{{ getLangValue('my.product-line', 'table_header3') }}</div>
                                <div v-if="formData.style.length" class="d-flex flex-wrap my-2">
                                    <div v-for="(item, k) in formData.style" :key="k"
                                        style="width: 100px; text-align: center;" class="mx-2">
                                        <img v-if="setType(item.name || item.filename) == 'image'" :src="item.url"
                                            width="100" style="height: auto;">
                                        <i class="ri-file-text-line text-secondary" v-else style="font-size: 60px;"></i>
                                        <div>{{ item.name || item.filename }}</div>
                                    </div>
                                </div>
                            </div>
                            <div style="width: 100%;min-height: 40px;" class="mx-2 my-3">
                                <div>{{ getLangValue('my.product-line', 'table_header4') }}</div>
                                <div v-if="formData.pattern.length" class="d-flex flex-wrap my-2">
                                    <div v-for="(item, k) in formData.pattern" :key="k"
                                        style="width: 100px;text-align: center;" class="mx-2">
                                        <img v-if="setType(item.name || item.filename) == 'image'" :src="item.url"
                                            width="100" style="height: auto;">
                                        <i class="ri-file-text-line  text-secondary" v-else
                                            style="font-size: 60px;"></i>
                                        <div>{{ item.name || item.filename }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="modal-footer">
                    <button @click="cancelFunction" type="button" class="btn btn-light" data-bs-dismiss="modal">{{
                        getLangValue('base.cancel') }}</button>
                    <button id="cancelBTn" type="button" class="btn btn-light" data-bs-dismiss="modal"
                        style="display: none;">{{
                            getLangValue('base.cancel') }}</button>
                    <button v-permit="['my.production-line.modify', 'my.production-line.add']" @click="okFunction"
                        type="button" class="btn btn-primary " v-if="formType !== 'view'"
                        style="background-color: #0AB39C;border-color: unset;">{{
                            getLangValue('base.confirm') }}</button>
                    <button v-permit="'my.production-line.modify'" @click="editFunction" type="button"
                        class="btn btn-primary " v-else style="background-color: #0AB39C;border-color: unset;">{{
                            getLangValue('base.edit') }}</button>
                </div>
                <!-- style="background-color: #0AB39C; color: white;" -->
            </div><!-- /.modal-content -->
        </div><!-- /.modal-dialog -->
    </div>
</template>
<style scoped lang="scss">
.is-invalid {
    border: 1px solid #f06548;
    border-radius: 4px;

    .el-input--suffix {
        border: 1px solid #f06548 !important;
        border-radius: 4px;
        height: 100%;
    }
}


:deep(.el-select--large .el-select__wrapper) {
    height: 100%;
    min-height: unset !important;
}

.disableDropZone {
    pointer-events: none;
}

:deep(.product-img-slider .swiper-slide) {
    min-width: 70px;
    justify-content: center;
}

:deep(.el-radio-button__original-radio:checked+.el-radio-button__inner) {
    background-color: #0AB39C;
    border-color: #0AB39C;
}
</style>

<style>
.is-invalid1224 {
    border: 1px solid #f06548 !important;
    border-radius: 4px;

}

.my-el {
    .el-input--suffix {
        height: 100%;
    }
}
</style>